"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles = function (overrideClasses) { return (__assign({ radioGroupHeader: function (_a) {
        var fontSize = _a.fontSize;
        return ({
            color: "#00000099",
            fontSize: fontSize || 20,
            letterSpacing: 0,
            fontWeight: 300,
        });
    }, radioLabel: function (_a) {
        var fontSize = _a.fontSize;
        return ({
            color: "#000000DE",
            fontSize: fontSize || 18,
            letterSpacing: 0,
            fontWeight: 600,
        });
    }, selectLabel: { color: "#000", fontWeight: 300, letterSpacing: 0 }, checkboxLabel: {
        fontFamily: "Roboto",
        fontSize: 16,
        letterSpacing: 0,
        lineHeight: 0.25,
        color: "#707070",
    } }, overrideClasses)); };
exports.default = styles;
//# sourceMappingURL=styles.js.map